import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { RealmsOverviewComponent } from './realms/realms-overview/realms-overview.component';
import { InquiriesOverviewComponent } from './inquiries/inquiries-overview/inquiries-overview.component';
import { DebugComponent } from './debug/debug.component';
import { StaticTemplateOverviewComponent } from './templates/static-template-overview/static-template-overview.component';
import { HangfireComponent } from './hangfire/hangfire.component';
import { TenantEmployeeDetailComponent } from './realms/realm-details/tenant-employee-detail/tenant-employee-detail.component';
import { Roles } from './core/guards/roles';
import { confirmSmsTextDrafts } from './sms-texts/sms-texts.guard';
import type { TenantWorkflowEditorRouteComponent } from './workflows/tenant-workflow-editor-route.component';

const routes: Routes = [
  { path: '', component: RealmsOverviewComponent, canActivate: [authGuard] },
  {
    path: 'realm/:tenantIdentifier',
    loadComponent: () =>
      import('./realms/realm-details/realm-details-overview/realm-details-overview.component').then(
        (component) => component.RealmDetailsOverviewComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'realm/:tenantIdentifier/workflows',
    loadComponent: () =>
      import('./workflows/tenant-workflow-overview-page.component').then(
        (component) => component.TenantWorkflowOverviewPageComponent,
      ),
    canActivate: [authGuard],
    data: { roles: [Roles.PlatformAdmin] },
  },
  {
    path: 'realm/:tenantIdentifier/workflows/:slug',
    loadComponent: () =>
      import('./workflows/tenant-workflow-editor-route.component').then(
        (component) => component.TenantWorkflowEditorRouteComponent,
      ),
    canActivate: [authGuard],
    canDeactivate: [
      (component: TenantWorkflowEditorRouteComponent) =>
        component.canDeactivate(),
    ],
    runGuardsAndResolvers: 'pathParamsChange',
    data: { roles: [Roles.PlatformAdmin] },
  },
  {
    path: 'realm/:tenantIdentifier/employee/:employeeId',
    component: TenantEmployeeDetailComponent,
    canActivate: [authGuard],
  },

  {
    path: 'inquiries',
    component: InquiriesOverviewComponent,
    canActivate: [authGuard],
  },
  {
    path: 'realm/:tenantIdentifier/inquiry/:inquiryId',
    loadComponent: () =>
      import('./inquiries/inquiry-details/inquiry-details.component').then(
        (component) => component.InquiryDetailsComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'sms-texts',
    loadComponent: () =>
      import('./sms-texts/sms-texts.component').then(
        (component) => component.SmsTextsComponent,
      ),
    canActivate: [authGuard],
    canDeactivate: [confirmSmsTextDrafts],
    data: { roles: [Roles.PlatformAdmin] },
  },
  {
    path: 'static-templates',
    component: StaticTemplateOverviewComponent,
    canActivate: [authGuard],
  },
  {
    path: 'debug',
    component: DebugComponent,
    canActivate: [authGuard],
  },
  {
    path: 'hangfire',
    component: HangfireComponent,
    canActivate: [authGuard],
  },
  {
    path: 'revenue/graphs/:chart',
    loadComponent: () =>
      import('./subscriptions/revenue/revenue-graph-page.component').then(
        (component) => component.RevenueGraphPageComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'revenue',
    loadComponent: () =>
      import('./subscriptions/revenue/revenue-dashboard.component').then(
        (component) => component.RevenueDashboardComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: '**',
    title: 'Seite nicht gefunden',
    data: { hideNavigation: true },
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        (module) => module.NotFoundComponent,
      ),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
